import React from "react";
import { CopyIcon, CryptoNetworks, SuccessWallet, WalletReadyIcon } from "asset/icons";
import { toast } from "react-toastify";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "component/ui/Dialog";
import { Button } from "component/ui/Button";
import { useNavigate } from "react-router-dom";

const OpenWalletSuccessModal = ({
    isOpen,
    currencyCode = "GBP",
    walletDetails = {},
    onClose,
    onBackToDashboard,
}) => {
  const navigate = useNavigate();
    if (!isOpen) return null;

    const currency = String(currencyCode || walletDetails?.currency || "").toUpperCase();
  const isCrypto = ["USDC", "USDT"].includes(currency);

    const accountNumber =
        walletDetails?.accountNumber ||
        walletDetails?.iban ||
        walletDetails?.account_no ||
        "";
    const bankName =
        walletDetails?.bankName ||
        walletDetails?.bank ||
        walletDetails?.bank_name ||
        "Tradevu Wallet";
    const accountName =
        walletDetails?.accountName ||
        walletDetails?.account_name ||
        walletDetails?.businessName ||
        "-";
    const sortCode =
        walletDetails?.sortCode ||
        walletDetails?.sort_code ||
        "";
    const routingNumber =
        walletDetails?.routingNumber ||
        walletDetails?.routing_number ||
        "";
    const iban =
        walletDetails?.iban && walletDetails?.iban !== accountNumber
            ? walletDetails.iban
            : "";
    const address =
        walletDetails?.address ||
        walletDetails?.depositAddress ||
        "";

    const handleCopy = (text, label = "Copied to clipboard") => {
        if (!text) return;
        navigator.clipboard.writeText(String(text));
        toast.success(label);
    };

    const handleCopyAll = () => {
        const lines = [
            `Account Name: ${accountName}`,
            `Account Number: ${accountNumber}`,
            `Bank Name: ${bankName}`,
            sortCode ? `Sort Code: ${sortCode}` : null,
            routingNumber ? `Routing Number: ${routingNumber}` : null,
            iban ? `IBAN: ${iban}` : null,
        ].filter(Boolean);

        navigator.clipboard.writeText(lines.join("\n"));
        toast.success("All account details copied to clipboard");
    };

    const handleClose = () => {
        if (onBackToDashboard) onBackToDashboard();
        else if (onClose) onClose();
    };

    const detailsList = [
        accountNumber ? { label: "Account number", value: accountNumber } : null,
        bankName ? { label: "Bank name", value: bankName } : null,
        accountName ? { label: "Account name", value: accountName } : null,
        sortCode ? { label: "Sort code", value: sortCode } : null,
        routingNumber ? { label: "Routing number", value: routingNumber } : null,
        iban ? { label: "IBAN", value: iban } : null,
    ].filter(Boolean);

  const navigateToWallet = () => {
    onClose();
    navigate(`/wallets`);
  };

    return (
        <Dialog open={isOpen} onOpenChange={(open) => !open && handleClose()}>
            <DialogContent
                showCloseButton={true}
          className="max-w-[500px] sm:p-7 rounded-[18px] bg-white overflow-hidden"
            >
          <div className="flex p-6 pb-3 flex-col items-center gap-2 text-center">
              <SuccessWallet className="size-20" />

                    <DialogTitle className="text-xl sm:text-2xl font-bold text-[#101828] tracking-tight">
              Your {currency} wallet is being setup
                    </DialogTitle>

            <DialogDescription className="text-sm text-[#667085] -mt-1 w-[75%] mx-auto">
              We’re reviewing your details. The wallet will be available within a few minutes.
                    </DialogDescription>
                </div>

          {/* {isCrypto ? (
                    <div className="my-4 space-y-3">
                        {address && (
                <div className="bg-[#F8FAFC] p-2 rounded-lg">
                                <div className="flex justify-between items-center gap-2">
                    <span className="text-xs font-medium text-[#667085]">
                                        Deposit address
                                    </span>
                                    <div className="flex items-center gap-2">
                                        <span className="font-mono text-xs sm:text-sm text-[#101828] break-all">
                                            {address}
                                        </span>
                                        <button
                                            type="button"
                                            onClick={() => handleCopy(address, "Deposit address copied")}
                        className="p-1"
                      >
                        <CopyIcon color="#45556C" className="w-3.5 h-3.5" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
              <div className="bg-[#F8FAFC] flex justify-between items-center p-2 rounded-lg">
                            <p className="text-xs sm:text-sm text-[#667085]">
                                Receive from these networks
                            </p>
                            <CryptoNetworks />
                        </div>
                    </div>
                ) : (
              <div className="bg-[#F8FAFC] p-3 rounded-lg my-4 space-y-3 text-sm">
                        {detailsList.map(({ label, value }) => (
                            <div key={label} className="flex justify-between items-center gap-3">
                            <span className="text-[#667085] text-xs sm:text-sm">{label}</span>
                                <div className="flex items-center gap-2">
                                    <span className="font-medium text-[#101828] text-xs sm:text-sm text-right">
                                        {value}
                                    </span>
                                    <button
                                        type="button"
                                        onClick={() => handleCopy(value, `${label} copied`)}
                                        className="p-1"
                                    >
                                      <CopyIcon color="#45556C" className="w-3.5 h-3.5" />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )} */}

          <div style={{ borderTop: "1px solid #F2F3FC" }} className="flex p-3 items-center justify-between">
                    <Button
              onClick={isCrypto ? navigateToWallet : handleClose}
                        className="bg-[#6F00FF] hover:bg-[#5E00DB] text-white font-medium text-sm px-6 py-2.5 rounded-lg shadow-sm transition-all ml-auto"
                    >
              Go to wallet
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default OpenWalletSuccessModal;
